

export default (tags) => !!tags.includes('archived')
